import React, { useState } from "react";

import { Flyout as UIFlyout } from "@showitinc/showit-wc";
import useEventEffect from "../../hooks/useEventEffect";

/**
 * Wraps the showit-ui Flyout to unmount children when closed
 * @param {Object} props
 * @param {(() => void)=} onOpen - effect to call on open
 * @param {} onClose - effect to call on close
 * @param {number=} shift
 * @param {string=} title
 *
 */
const Flyout = ({ children, onOpen, onClose, refSetter, ...props }) => {
  const [ref, setRef] = useState(null);
  const [open, setOpen] = useState(false);
  useEventEffect(ref, "si-open", () => {
    setOpen(true);
    onOpen && onOpen(ref);
  });
  useEventEffect(ref, "si-close", () => {
    setOpen(false);
    onClose && onClose();
  });

  return (
    <UIFlyout
      ref={(passedRef) => {
        refSetter && refSetter(passedRef);
        setRef(passedRef);
      }}
      {...props}
    >
      {open ? children : null}
    </UIFlyout>
  );
};

export default Flyout;
